import ButtonComponent from "@/Inputs/ButtonComponent";
import { Dialog, Transition } from "@headlessui/react";
import { Close } from "@mui/icons-material";
import { Fragment } from "react";
import parse from 'html-react-parser';

const DistributorSingleProductPopUp = ({
    productOpen,
    setProductOpen
}) => {

    return (
        <>
            <Transition appear show={(!!productOpen)} as={Fragment}>
                <Dialog as="div" className="relative z-20" onClose={() => console.log('close')}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#00000021]" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="z-[9999] mx-4 sm:mx-0 w-full max-w-[375px] transform mt-24 p-7 bg-white  text-left align-middle  transition-all rounded-md">
                                    <div className="text-right">
                                        <Close
                                            className="mb-1 ml-auto cursor-pointer"
                                            onClick={() => setProductOpen(null)}
                                        />
                                    </div>
                                    <div className="py-4">
                                        <h3 className="font-bold">
                                            Product Detail's
                                        </h3>
                                    </div>
                                    <div className="mx-auto">
                                        <div className="border-[#D8D8D8] border-b py-4 flex items-center gap-2.5 justify-between">
                                            <div className="w-full">
                                                <h6 className="text-base">{productOpen?.title} </h6>
                                            </div>
                                        </div>
                                        <div className="border-[#D8D8D8] border-b py-4 flex items-center gap-2.5 justify-between">
                                            <div className="w-full">
                                                <p className="text-sm leading-6">
                                                    {productOpen?.description1 && parse(productOpen?.description1)}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="border-inputcolor py-4 flex items-center gap-2.5 justify-between">
                                            <div className="w-full">
                                                {/* <h6 className="text-base">We suggest</h6> */}
                                                <p className="text-sm leading-6">
                                                    {productOpen?.description2 && parse(productOpen?.description2)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <ButtonComponent classes="primary-button rounded-none w-full mb-0" onClick={() => setProductOpen(null)}>
                                        Close
                                    </ButtonComponent>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
};
export default DistributorSingleProductPopUp;
